export const KITCHEN_ISLAND = {
    id: "2-island",
    name: "Kitchen Island",
    levels: [
        {
            tileSize: 256,
            size: 256,
            fallbackOnly: true,
        },
        {
            tileSize: 512,
            size: 512,
        },
        {
            tileSize: 512,
            size: 1024,
        },
        {
            tileSize: 512,
            size: 2048,
        },
    ],
    faceSize: 2048,
    initialViewParameters: {
        yaw: 0.00808702780357784,
        pitch: 0.6524340931455015,
        fov: 1.403086486818207,
    },
    linkHotspots: [
        {
            yaw: -0.04592867210906881,
            pitch: 0.264764629900764,
            rotation: 6.283185307179586,
            target: "1-range",
        },
        {
            yaw: -0.6922761393706214,
            pitch: 0.20613383976159838,
            rotation: 6.283185307179586,
            target: "3-nook",
        },
        {
            yaw: -1.55754985367048,
            pitch: 0.26727844402370415,
            rotation: 0,
            target: "4-prep",
        },
        {
            yaw: 0.8888592952354628,
            pitch: 0.08581669185794638,
            rotation: 3.9269908169872414,
            target: "0-init",
        },
        {
            yaw: -2.931027911576896,
            pitch: 0.4444488866359091,
            rotation: 0,
            target: "5-dining",
        },
    ],
    infoHotspots: [
        {
            yaw: 0.521051282306308,
            pitch: 0.47802733475431225,
            title: `Secret Center Cake Pan`,
            text: /*html*/ `
      <ul>
       <li><b>#100666</b></li>
       <li><b>USD</b> $45 | <b>CAD</b> $58</li>
       <li>3-year guarantee</li>
       <li>Hand wash | Oven-safe to 450°F (230°C)</li>
       <li>9" (23.5-cm) diameter | Includes 2 pans and 2 inserts</li>
       <li>
         Heavy weight carbon-steel export construction with exclusive nonstick
         coating for easy release and cleaning.
       </li>
       <li>Make fun cakes with a surprise inside!</li>
       <li>
         You can add a surprise filling to the entire cake or personalize each
         slice with something special like sprinkles, fruit, or chocolate
         candies.
       </li>
       <li>
         The pans’ unique cake shape shows you where to slice so each piece will
         contain your hidden surprise until your guests dig in.
       </li>
       <li>Holds a standard box cake mix.</li>
       <li>
         <b>Great for:</b>
         birthdays, holidays, gender reveals and more.
       </li>
     </ul>
  `,
            images: [
                `<img height="640" alt="secret-center-cake-pan-01.jpeg" src="https://pamperedchef.widen.net/content/fwfv2fouef/jpeg/secret-center-cake-pan-01.jpeg?h=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img height="640" alt="secret-center-cake-pan-02.jpeg" src="https://pamperedchef.widen.net/content/ovfdseuo9w/jpeg/secret-center-cake-pan-02.jpeg?h=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img height="640" alt="secret-center-cake-pan-03.jpeg" src="https://pamperedchef.widen.net/content/xum58z7hrc/jpeg/secret-center-cake-pan-03.jpeg?h=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="secret-center-cake-pan-04.jpeg" src="https://pamperedchef.widen.net/content/qmfrsaeckb/jpeg/secret-center-cake-pan-04.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
            ],
            videos: [
                `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe src="https://pamperedchef.widen.net/view/video/kpxrmacvb3/video-product-secret-center-cake-pan-demo-usca.mp4?u=intbhg" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;" ></iframe></div>`,
            ],
        },
        {
            yaw: -0.05255258477594005,
            pitch: 0.5065264512482059,
            title: "Dulce de Leche Cake Mix",
            text: `
      <ul>
        <li><b>#100646</b></li>
        <li><b>USD</b> $10 | <b>CAD</b> $12.50</li>
        </li>
        <li>Gluten-Free, Kosher | Contains wheat, barley, and milk.</li>
        <li>
          19 oz. (538 g); makes one 9" x 13" (23-cm x 33-cm) cake or two 9" cakes.
        </li>
        <li>
          Make a rich, decadent, buttery cake with a sweet caramel flavor.
        </li>
        <li>
          Just add butter, vegetable oil, eggs, and milk.
        </li>
        <li>
          This high-quality, easy-to-use mix takes the standing and stirring out of dulce de leche, so you can bake an
          amazing and impressive cake in under an hour.
        </li>
        <li><b>Also in the Cake Set:</b>
          9" x 13" (23 x 33-cm) Pan With Lid and Dulce de Leche Cake Mix
        </li>
      </ul>`,
            images: [
                `<img height="640" alt="dulce-leche-mix-01.jpeg" src="https://pamperedchef.widen.net/content/9cvxm8zsuz/jpeg/dulce-leche-mix-01.jpeg?h=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img height="640" alt="dulce-leche-mix-02.jpeg" src="https://pamperedchef.widen.net/content/almhfidmoo/jpeg/dulce-leche-mix-02.jpeg?h=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img height="640" alt="dulce-leche-mix-03.jpeg" src="https://pamperedchef.widen.net/content/rzqt2i0tne/jpeg/dulce-leche-mix-03.jpeg?h=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img height="640" alt="dulce-leche-mix-03.jpeg" src="https://pamperedchef.widen.net/content/uzekiiqcq3/jpeg/dulce-leche-mix-04.jpeg?h=640&keep=c&crop=yes&color=cccccc&quality=80">`,
            ],
        },
        {
            yaw: -0.6208377111874768,
            pitch: 0.38425167226326806,
            title: "Pan With Lid",
            title: `Pan With Lid`,
            subhead: `9" x 13" (23 x 33-cm) Pan With Lid`,
            text: `
        <ul>
          <li><b>#100667</b></li>
          <li><b>USD</b> $39 | <b>CAD</b> $49</li>
          <li>3-year guarantee</li>
          <li>Hand wash | Oven-safe to 450°F (230°C)</li>
          <li>
            Made with carbon steel with Pampered Chef’s exclusive high-quality nonstick coating for easy release and cleaning.
          </li>
          <li>Bake &amp; take your favorite foods anywhere!</li>
          <li>
            The snap-on lid provides an easy storage solution, so you can store and easily transport your delicious baked goods.
          </li>
          <li>
            <b>Great for:</b>
            sheet cake, casseroles, or a batch of brownies.
          </li>
          <li>
            Also in the
            <b>Cake Set:</b>
            9" x 13" (23 x 33-cm) Pan With Lid and Dulce de Leche Cake Mix
          </li>
        </ul>
  `,
            images: [
                `<img width="640" alt="9x13-pan-lid-01.jpeg" src="https://pamperedchef.widen.net/content/f3kst6ttkl/jpeg/9x13-pan-lid-01.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="9x13-pan-lid-02.jpeg" src="https://pamperedchef.widen.net/content/g13g4psc69/jpeg/9x13-pan-lid-02.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="9x13-pan-lid-03.jpeg" src="https://pamperedchef.widen.net/content/qzo4ruvvgm/jpeg/9x13-pan-lid-03.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
            ],
            videos: [
                `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe src="https://pamperedchef.widen.net/view/video/f7wlpdaifz/video-product-ss22-9x13-pan-with-lid-loop-virtual-kitchen-usca.mp4" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;" ></iframe></div>`,
            ],
            recipes: [
                {
                    title: "Peach Bread Pudding",
                    element: `<img width="150" height="150" class="recipe-preview-img-wrap" alt="recipe-post-08.jpeg" src="https://pamperedchef.widen.net/content/iobokbloir/jpeg/recipe-post-08.jpeg?w=200&h=200&position=c&color=ffffffff&quality=80">`,
                    link: `https://pamperedchef.widen.net/s/rznsfpkdv2/recipe-post-08`,
                },
            ],
        },
    ],
};
